<template>
  <v-container fluid>
    <v-row justify="center" class="ma-0">
      <manual-upload-form />
    </v-row>
  </v-container>
</template>

<script>
import ManualUploadForm from "../../components/AdminOnly/ManualUploadForm"

export default {
  name: "CreateManualUpload",
  components: {ManualUploadForm},
  created() {
    this.$appMng.setTitle("Uploads manuais")
    if (!this.$store.state.user.userData.blAllowAdmin) {
      this.$router.push('/401')
    }
  }
}
</script>

<style scoped>

</style>